import { logger } from './LoggerService';

class MissingAssetService {
  private static STORAGE_KEY = 'usagi_missing_assets';
  private missing = new Set<string>();

  constructor() {
    try {
      const raw = localStorage.getItem(MissingAssetService.STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          parsed.forEach((k) => this.missing.add(String(k)));
        }
      }
    } catch {
      // ignore (quota / private mode)
    }
  }

  report(name: string, kind?: string): void {
    const key = kind ? `${kind}:${name}` : name;
    if (this.missing.has(key)) {
      return;
    }
    this.missing.add(key);
    logger.warn(`[missing-asset] ${key}`);
    try {
      localStorage.setItem(
        MissingAssetService.STORAGE_KEY,
        JSON.stringify(Array.from(this.missing).sort()),
      );
    } catch {
      // localStorage may be unavailable (private mode / quota) — non-critical
    }
  }

  getAll(): string[] {
    return Array.from(this.missing).sort();
  }

  download(): void {
    const data = JSON.stringify(this.getAll(), null, 2);
    const blob = new Blob([data], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `missing-assets-${Date.now()}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  clear(): void {
    this.missing.clear();
    try {
      localStorage.removeItem(MissingAssetService.STORAGE_KEY);
    } catch {
      // localStorage may be unavailable (private mode / quota) — non-critical
    }
  }
}

export const missingAssetService = new MissingAssetService();
